var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { "body-class": "p-4" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "d-none d-lg-flex flex-row justify-content-center",
              attrs: { cols: "1" },
            },
            [_c("div", { staticClass: "step" }, [_vm._v("2")])]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "11" } },
            [
              _c("p", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("drip-campaigns.stages.editContact.question"))
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("drip-campaigns.stages.editContact.description")
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex flex-row align-items-center",
                      attrs: { cols: "12", md: "3", lg: "2" },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "bold text-regular-gray font-sm" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("drip-campaigns.yourName")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "col-md-8 col-lg-6 col-12",
                      attrs: { autocomplete: "off" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c("material-input", {
                        staticClass: "position-relative",
                        attrs: {
                          id: "from-name",
                          name: "name",
                          label: _vm.$t("global.words.name"),
                          "label-for": "drip-campaign-from-name",
                          "custom-expression": "currentCampaign.fromName",
                        },
                        model: {
                          value: _vm.fromName,
                          callback: function ($$v) {
                            _vm.fromName = $$v
                          },
                          expression: "fromName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex flex-row align-items-center",
                      attrs: { cols: "12", md: "3", lg: "2" },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "bold text-regular-gray font-sm pt-3" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("global.doorr.emailAddress")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", md: "8", lg: "6" } },
                    [
                      _c(
                        "b-row",
                        { staticClass: "align-items-center" },
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "div",
                                { staticClass: "form-group-material" },
                                [
                                  _c("marketing-emails-select", {
                                    ref: "select",
                                    attrs: {
                                      id: "select-email",
                                      emails: _vm.GET_MARKETING_EMAILS,
                                      "space-classes": "col-12 mt-3 px-0",
                                      value: _vm.currentCampaign.emailId,
                                      name: "value",
                                      "init-on-mounted": true,
                                      multiple: false,
                                      required: true,
                                    },
                                    on: { change: _vm.handleEmailChange },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("transition", { attrs: { name: "slide" } }, [
                                _vm.selectedEmail &&
                                !_vm.isSelectedEmailVerified
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "mt-2",
                                        attrs: {
                                          id: "verify-container collapse",
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-regular-gray m-0",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$tc(
                                                    "global.words.click",
                                                    1
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "clickable text-primary",
                                                attrs: {
                                                  id: "verify-existing-email",
                                                },
                                                on: {
                                                  click:
                                                    _vm.handleVerifySelectedEmail,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("global.words.here")
                                                  ) + "\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "drip-campaigns.stages.editContact.toConfirmVerification"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-col", { staticClass: "col-auto" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "text-uppercase font-sm bold text-primary clickable ml-2",
                                attrs: { id: "create-email" },
                                on: { click: _vm.handleCreateEmail },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-plus text-primary",
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("global.words.create")) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "pt-2" },
                [
                  _c("b-col", { attrs: { cols: "12", md: "3", lg: "2" } }, [
                    _c(
                      "p",
                      { staticClass: "bold text-regular-gray font-sm mb-0" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "drip-campaigns.stages.editContact.contactInfo"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "text-primary small clickable",
                        on: { click: _vm.handleOpenDisclaimerModal },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("drip-campaigns.stages.editContact.askFor")
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", md: "8", lg: "6" } },
                    [
                      _c("address-section", {
                        attrs: {
                          address: _vm.address,
                          "custom-expressions": _vm.addressCustomExpressions,
                        },
                        on: { change: _vm.handleAddressChange },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("create-email-modal", {
        ref: "createEmailModal",
        attrs: {
          "force-show-verify": _vm.showEmailVerify,
          "force-email-to-verify": _vm.selectedEmail,
        },
      }),
      _vm._v(" "),
      _c("marketing-address-disclaimer-modal", { ref: "disclaimerModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }